/**
 * Depth data lives in the vector ENC. Raster providers (RYA raster, Antares) and
 * the OpenSeaMap tile source carry no soundings, depth areas or quality (M_QUAL)
 * polygons, so anything that reads depth off the chart has nothing to read there.
 *
 * The depth-dependent features (grounding look-ahead, depth-under-keel alarm,
 * CATZOC overlay, route hazard scan) used to fail SILENTLY on those sources:
 * the alarm just never fired, the overlay drew nothing, the scan found nothing,
 * and there was no way to tell "all clear" from "this chart can't tell me". That
 * silence is dangerous, so each feature now checks this and says so out loud.
 *
 * Note this is deliberately per-PROVIDER, not per-location: even where stale
 * vector training cells happen to overlap a raster view, the chart we're
 * actually navigating on has no depth, so we treat depth as unavailable rather
 * than quietly reading a hidden cell that doesn't match what's on screen.
 */
import { getProvider } from './providers';

/** The one message every depth-dependent feature shows when it can't read depth. */
export const NO_DEPTH_ON_SOURCE =
  'Depth data not available on this chart source (switch to a vector chart).';

/** True only when the active provider is a vector ENC that actually carries depth. */
export function providerHasDepthData(providerId: string): boolean {
  return getProvider(providerId).kind === 'vector';
}
